
import { Vue, Prop } from 'vue-property-decorator';

export default class PreferenceRow extends Vue {
    @Prop(String) readonly text!: string;
    @Prop(String) readonly desc?: string;
}
